import { DomApplier } from '../cssFeatures.types'
import { TimeAnimationOptions } from '@wix/thunderbolt-becky-types'
import { getVariantSelectors } from '../../utils/variantsUtils'

const MOTION_EFFECTS_ENTER_DONE_SELECTOR = ':not([data-motion-enter="done"])'

function getInitialFrame(
	item: TimeAnimationOptions | null,
	defaultFrameStyle?: Record<string, any> | null
): Record<string, any> {
	const OPACITY_ZERO = { opacity: 0 }
	const UNSET_OPACITY_ZERO = { opacity: 'unset' }
	// TODO: implement for keyframeEffect
	if (item?.namedEffect && (item.fill === 'backwards' || item.fill === 'both')) {
		// TODO: implement this properly - currently just following impl. of ScreenIn
		return OPACITY_ZERO
	} else if (defaultFrameStyle?.opacity === 0) {
		return UNSET_OPACITY_ZERO
	}

	return {}
}

function transformToFrameSelector(selectors: Array<string>) {
	return selectors.map((selector_) => `${selector_}${MOTION_EFFECTS_ENTER_DONE_SELECTOR}`).join(',')
}

export const motionEffectsDomApplier: DomApplier<'motionEffects'> = (
	{ id: compId },
	idSelector,
	breakpointId,
	{ motionEffects },
	cssContext
) => {
	if (motionEffects) {
		// fetches initial frame from all effects per a given breakpointId
		return motionEffects
			.flatMap(({ data: breakpointToEffect, variants }) => {
				const { default: defaultBreakpoint, ...restOfBreakpoints } = breakpointToEffect

				const defaultFrameStyles = Object.entries(defaultBreakpoint).map(([variantKey, item]) => ({
					selectors: getVariantSelectors(variantKey, variants, compId, cssContext),
					frame: getInitialFrame(item),
				}))

				if (breakpointId === 'default') {
					return defaultFrameStyles
				}

				return restOfBreakpoints[breakpointId]
					? Object.entries(restOfBreakpoints[breakpointId]).map(([variantKey, item]) => {
							const variantSelectors = getVariantSelectors(variantKey, variants, compId, cssContext)
							const variantSelectorString = variantSelectors.join()
							const defaultVariant = defaultFrameStyles.find(
								(variant) => variant.selectors.join() === variantSelectorString
							)

							// TODO: may need to also implement check if there's an equality between different selectors inside the variant's selector list
							return {
								selectors: variantSelectors,
								frame: getInitialFrame(item, defaultVariant?.frame),
							}
					  })
					: []
			})
			.reduce((styleRules, effectVariants) => {
				// transform all selector lists to a single selector string
				const selector = transformToFrameSelector(effectVariants.selectors)

				// merge all style properties per selector for all effects - so we get a single frame per selector
				if (styleRules[selector]) {
					styleRules[selector] = Object.assign(styleRules[selector], effectVariants.frame)
				} else {
					styleRules[selector] = effectVariants.frame
				}

				return styleRules
			}, {} as Record<string, {}>)
	}

	return null
}
